export default __webpack_public_path__ + "static/media/mail.07790abe.gif";